export type WixDesignSystemProviderProps = {
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element.
   * @internal
   */
  className?: string;
  as?: 'span' | 'div';
  children?: React.ReactNode;
  features?: {
    newColorsBranding?: boolean;
    /** Not recommended. Hides certain elements, which can negatively affect accessibility. */
    compactMode?: boolean;
  };
  theme?: { className: string };
  /** Define the user locale to be used and effect some translation and localization (like DatePicker) - this should be compliant to Intl language codes*/
  locale?: string;
  /** Define id that will be applied to the header of a main page */
  pageHeaderId?: string;
  /** Controls whether mobile styles should be applied on mobile viewport. DO NOT enable if using WDS inside an iframe. */
  mobile?: boolean;
};
